import { ISampleDevelopmentHl } from '../../models/sampleDevelopmentHl.model';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  FETCH_SAMPLE_DEVELOPMENT_HL_LIST,
  FETCH_SAMPLE_DEVELOPMENT_HL,
  CREATE_SAMPLE_DEVELOPMENT_HL,
  UPDATE_SAMPLE_DEVELOPMENT_HL,
  CLEAR_SAMPLE_DEVELOPMENT_HL,
  SUBMIT_SAMPLE_DEVELOPMENT_HL_FOR_APPROVAL,
} from './sampleDevelopmentHl.actions';
import { SampleDevelopmentHlState } from './sampleDevelopmentHl.types';

const initialState: SampleDevelopmentHlState = {
  errorMessage: '',
  item: {} as Readonly<ISampleDevelopmentHl>,
  items: [] as ISampleDevelopmentHl[],
  loading: false,
  totalItems: 0,
};

export default (
  state: SampleDevelopmentHlState = initialState,
  action: AppAction,
): SampleDevelopmentHlState => {
  switch (action.type) {
    case REQUEST(FETCH_SAMPLE_DEVELOPMENT_HL_LIST):
    case REQUEST(FETCH_SAMPLE_DEVELOPMENT_HL):
    case REQUEST(CREATE_SAMPLE_DEVELOPMENT_HL):
    case REQUEST(UPDATE_SAMPLE_DEVELOPMENT_HL):
      return { ...state, loading: true };
    case SUCCESS(FETCH_SAMPLE_DEVELOPMENT_HL_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_SAMPLE_DEVELOPMENT_HL_LIST):
    case FAILURE(FETCH_SAMPLE_DEVELOPMENT_HL):
    case FAILURE(CREATE_SAMPLE_DEVELOPMENT_HL):
    case FAILURE(UPDATE_SAMPLE_DEVELOPMENT_HL):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(UPDATE_SAMPLE_DEVELOPMENT_HL):
    case SUCCESS(FETCH_SAMPLE_DEVELOPMENT_HL):
    case SUCCESS(CREATE_SAMPLE_DEVELOPMENT_HL):
    case SUCCESS(SUBMIT_SAMPLE_DEVELOPMENT_HL_FOR_APPROVAL):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_SAMPLE_DEVELOPMENT_HL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
